import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';

export class TeamModel extends BaseModel implements Deserializable {

  // columns
  name: any;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}
